import type { DocumentAllowedExtensionsResponse } from '@views/screens/common/data-provider/document-allowed-extension-list/api';

export const normalizeDocumentAllowedExtensionsList = (list: DocumentAllowedExtensionsResponse) => {
  if (!list) {
    return [];
  }

  return list[0]?.allowExtension.split(',');
};
